// API wire-up removes this file, the repository scenario param and useDocumentLabelsController.
import { T360_TAG_CONFIG } from './tagConfig';
import type {
    T360DocumentTags,
    T360LeafTag,
    T360RepositoryTagMatches,
    T360TagConfig,
} from './types';
import { hasMatchingTag } from './utils';

export const REPOSITORY_LABELS_SCENARIOS = [
    'review',
    'not-clustered',
    'save-fails',
    'many-tags',
] as const;
export type RepositoryLabelsScenario =
    (typeof REPOSITORY_LABELS_SCENARIOS)[number];

const EXTRA_TAG_COUNT = 120;

interface FixtureDocumentLocation {
    documentId: number;
    fileId: number;
    folderPath: string;
}

const FIXTURE_DOCUMENT_LOCATIONS: FixtureDocumentLocation[] = [
    {
        documentId: 1,
        fileId: 101,
        folderPath: 'MSN1',
    },
    {
        documentId: 2,
        fileId: 101,
        folderPath: 'MSN1',
    },
    {
        documentId: 3,
        fileId: 201,
        folderPath: 'MSN2',
    },
];

function main(value: string): T360LeafTag {
    return { key: 'main', value };
}

const TAGS_BY_ID_MOD_5: Record<number, T360DocumentTags | null> = {
    1: { tags: [main('job-card')], status: 'to_review', source: 'leaf' },
    2: {
        tags: [main('arc'), { key: 'arc_type', value: 'form1' }],
        status: 'confirmed',
        source: 'leaf',
    },
    3: {
        tags: [
            main('tech-log'),
            main('flight-log'),
            { key: 'log_type', value: 'pilot' },
        ],
        status: 'confirmed',
        source: 'document',
    },
    4: { tags: [], status: 'confirmed', source: 'document' },
    0: null,
};

export function fixtureDocumentTags(
    documentId: number,
): T360DocumentTags | null {
    return TAGS_BY_ID_MOD_5[documentId % 5];
}

export function buildFixtureTagMatches(
    tags: readonly string[],
    documentTagsFor: (documentId: number) => T360DocumentTags | null,
): T360RepositoryTagMatches | null {
    if (tags.length === 0) return null;
    const matching = FIXTURE_DOCUMENT_LOCATIONS.filter(({ documentId }) =>
        hasMatchingTag(documentTagsFor(documentId), tags),
    );
    const files = new Map(
        matching.map(({ fileId, folderPath }) => [fileId, folderPath]),
    );
    return {
        files: [...files].map(([id, folderPath]) => ({ id, folderPath })),
        documentIds: matching.map(({ documentId }) => documentId),
    };
}

export function buildFixtureTagConfig(
    scenario: RepositoryLabelsScenario,
): T360TagConfig {
    if (scenario !== 'many-tags') return T360_TAG_CONFIG;
    const extras = Array.from({ length: EXTRA_TAG_COUNT }, (_, index) => {
        const number = String(index + 1).padStart(3, '0');
        return { code: `extra-${number}`, name: `Extra tag ${number}`, facets: [] };
    });
    return { ...T360_TAG_CONFIG, classes: [...T360_TAG_CONFIG.classes, ...extras] };
}
